export const abilities = {
    patient: [
        'therapies.view',
        'therapies.create-user',
        'therapy-templates.view',
        'therapy-templates.instantiate',
        'tasks.view',
        'tasks.complete',
        'tasks.skip',
        'tasks.complete-retroactively',
        'components.view',
        'medicines.view',
        'engagement.view-own',
        'engagement.self-report',
        'engagement-levels.view',
        'profile.view-own',
        'profile.update-own',
    ],
};

export const rolePrecedence = ['admin', 'doctor', 'patient'];

// The doctor and admin console: after login we redirect there once.
export const otherAppUrl = process.env.VUE_APP_WEB_URL || 'http://localhost:8080';

export const landingPages = {
    patient: '/app',
};

export function abilitiesFor(roles = []) {
    const set = new Set();

    (roles || []).forEach((role) => {
        (abilities[role] || []).forEach((ability) => set.add(ability));
    });

    return Array.from(set);
}

export default abilities;
